import {
    LoginErpParam,
    LoginErpAfterSaleUsingGetParams,
    LoginDrpCombineUsingGetParams,
    LoginErpOrderByStatusUsingGetParams,
    LoginErpOrderDetailByOidUsingGetParams,
    GotoErpOrderDetailByOidUsingGetParams,
    GotoErpAfterSaleDetailByAsIdUsingGetParams,
    LoginErpMyChannelBillDetailUsingGetParams,
    LoginErpMyChannelLogUsingGetParams,
    LoginErpMyChannelSetDetailUsingGetParams,
    LoginErpOrderDetailByOwnerCoIdUsingGetParams,
    LoginErpMySupplierAfterSaleUsingGetParams,
    LoginErpAfterSaleDetailsUsingGetParams,
    CheckCreateShopRoleUsingGetParams,
    CheckCreateShopRoleResult
} from '@servicesTypings/companyRequest'
import { DrpCombineItemParam, ErpDrpCombineItem } from '@servicesTypings/goodsRequest'
import {
    companyRequest,
    goodsRequest,
    printerRequest,
    noPrefixRequest,
    securityRequest,
    drpRequest
} from '@/utils/request'

// 联登ERP页面
export function getErpUrl(url, params) {
    return noPrefixRequest.get(url, { params })
}

// 联登ERP页面(以路由url形式)
/**
 * 联登ERP页面(以路由url形式)
 */
export function getLoginErpByPath(data: LoginErpParam): API.Res<string> {
    return companyRequest.post('/joinLoginErp/loginErpByPath', { data })
}

// 跳转到erp售后页面
/**
 * 联登ERP售后
 */
export function getErpAfterSalePage(params: LoginErpAfterSaleUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpAfterSale', { params })
}

// 跳转到erp售后页面
export function getErpBatchSplitPage() {
    return companyRequest.get('/joinLoginErp/loginModifyOrderSplitRules')
}
// 跳转到erp组合装页面
/**
 * 联登ERP供应商组合商品
 */
export function getErpLoginDrpCombine(params: LoginDrpCombineUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginDrpCombine', { params })
}

// 跳转到erp订单页面
/**
 * 联登ERP订单列表
 */
export function getErpOrderPage(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpOrder')
}

// 跳转到erp供应商通用设定
/**
 * 联登ERP供应商通用设定页面
 */
export function getSupplierCommonSetPage(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSupplierCommonSet')
}

// 是否在新版供销设置白名单中
/**
 * 是否在新版供销设置白名单中
 */
export function getInNewSupplySetting(): API.Res<boolean> {
    return drpRequest.get('/supplyConfig/inNewSupplySetting')
}

// 订单异常跳转
/**
 * 联登ERP供应商通用设定页面(增加了弹出订单异常参数)
 */
export function loginErpSupplierCommonSetWithOrderError(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSupplierCommonSetWithOrderError')
}

// 跳转到erp供销商限定分销商品
/**
 * 联登ERP供销商限定分销商品
 */
export function getSupplierDisGoodsRulePage(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSupplierDisGoodsRule')
}

// 跳转到erp佣金费用规则
/**
 * 联登ERP供销商佣金费用规则
 */
export function getSupplierCommissionFeeRulePage(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpSupplierCommissionFeeRule')
}

// 查看组合商品明细
/**
 * 查询供应商组合商品
 */
export function getErpDetailData(data: DrpCombineItemParam): API.Res<ErpDrpCombineItem> {
    return goodsRequest.post('/buyer/supplier/queryDrpCombineItem', { data })
}

// 跳转到erp订单导出
export function getErpOrderExportPage() {
    return companyRequest.get('/joinLoginErp/loginErpExportOrder')
}

// 联登ERP导入发货
export function getErpOrderImportPage() {
    return companyRequest.get('/joinLoginErp/loginErpImportOrder')
}

// 联登ERP分销资金管理
export function getErpDistributionFundsPage() {
    return companyRequest.get('/joinLoginErp/loginErpDistributionFunds')
}

// 校验商家是否有导出订单的权限
export function checkExportAuthorityApi() {
    return companyRequest.get('/joinLoginErp/checkExportPower')
}

/** 供应商侧 */
// 联登ERP分仓管理
export function getWmsPartnerSubPosition() {
    return companyRequest.get('/joinLoginErp/loginErpWmsPartnerSubPosition')
}
// 联登ERP库存同步规则
export function getStockRuleList() {
    return companyRequest.get('/joinLoginErp/loginErpStockRuleList')
}

// 分销资金管理
export function getErpDistributionFunds() {
    return companyRequest.get('/joinLoginErp/loginErpDistributionFunds')
}

export function getSalesThemeAnalysis() {
    return companyRequest.get('/joinLoginErp/salesThemeAnalysis')
}
// 销售主题分析(财务)
export function getSalesFinanceThemeAnalysis() {
    return companyRequest.get('/joinLoginErp/salesFinanceThemeAnalysis')
}
// 联登ERP当日销售统计
export function getDailySalesStatistics() {
    return companyRequest.get('/joinLoginErp/dailySalesStatistics')
}

// 联登ERP采购退货
export function getPurchaseReturn() {
    return companyRequest.get('/joinLoginErp/loginErpPurchaseReturn')
}
// 联登ERP采购单管理页
export function getPurchaseManager() {
    return companyRequest.get('/joinLoginErp/loginErpPurchaseManager')
}
// 联登ERP采购入库
export function getPurchaseWarehousing() {
    return companyRequest.get('/joinLoginErp/loginErpPurchaseWarehousing')
}
// 组合装商品
export function getCombineItems() {
    return companyRequest.get('/joinLoginErp/loginErpCombineItems')
}

// 商品打印+
export function getErpGoodsPrint() {
    return companyRequest.get('/joinLoginErp/loginErpGoodsPrint')
}

// 联登ERP商品主题分析
export function getItemSkuReport() {
    return companyRequest.get('/joinLoginErp/loginErpItemSkuReport')
}
// 联登ERP售后主题分析
export function getAfterSaleReport() {
    return companyRequest.get('/joinLoginErp/loginErpAfterSaleReport')
}
// 联登ERP分销销售统计
export function getDrpOrderStatistics() {
    return companyRequest.get('/joinLoginErp/loginErpDrpOrderStatistics')
}
// 联登ERP   赠品规则
export function getErpGiftRule() {
    return companyRequest.get('/joinLoginErp/loginErpGiftRule')
}
// 联登ERP  店铺商品管理
export function getErpshopGoodsManage() {
    return companyRequest.get('/joinLoginErp/loginErpshopGoodsManage')
}
// 联登ERP快递主题分析
export function getExpressWmsReport() {
    return companyRequest.get('/joinLoginErp/loginErpExpressWmsReport')
}
// 联登ERP分销运费模板
export function getErpExpressFreight() {
    return companyRequest.get('/joinLoginErp/loginErpExpressFreight')
}

// 联登ERP订单列表
export function getErpOrder() {
    return companyRequest.get('/joinLoginErp/loginErpOrder')
}

// 联登ERP导出订单
export function getErpExportOrder() {
    return companyRequest.get('/joinLoginErp/loginErpExportOrder')
}

// 联登ERP导入第三方发货
export function getErpImportThird() {
    return companyRequest.get('/joinLoginErp/loginErpImportThird')
}

// 联登ERP售后
export function getErpAfterSale() {
    return companyRequest.get('/joinLoginErp/loginErpAfterSale')
}

// 跳转到erp分销订单页面
/**
 * 根据状态查询订单列表
 */
export function getDistributionErpOrderPage(params: LoginErpOrderByStatusUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpOrderByStatus', { params })
}

// 跳转erp订单页面 并筛选出该条订单 并跳出订单详情弹框
/**
 * 根据内部订单号查询订单详情
 */
export function loginErpOrderDetailByOid(params: LoginErpOrderDetailByOidUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpOrderDetailByOid', { params })
}

// 打开ERP订单详情页（ERP内）
/**
 * 根据内部订单号查询订单详情（内嵌erp使用）
 */
export function gotoErpOrderDetailByOid(params: GotoErpOrderDetailByOidUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/gotoErpOrderDetailByOid', { params })
}

// 打开ERP售后详情页（ERP内）
/**
 * 根据售后单号查询售后单详情（内嵌erp使用）
 */
export function gotoErpAfterSaleDetailByAsId(params: GotoErpAfterSaleDetailByAsIdUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/gotoErpAfterSaleDetailByAsId', { params })
}

// 联登ERP店铺管理
/**
 * 联登ERP店铺管理
 */
export function loginErpShop(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpShop')
}

// 联登ERP快递运费计算
/**
 * 联登ERP快递对账
 */
export function getErpCalFreight(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpCalFreight')
}

// 联登ERP供销商库存列表
/**
 * 联登ERP供销商库存列表
 */
export function loginDrpInventory(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginDrpInventory')
}

// 联登ERP运费计算配置
/**
 * 联登ERP运费计算配置
 */
export function loginErpFreightCalConfig(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpFreightCalConfig')
}

// 联登ERP我的分销商-供销对账明细
/**
 * 联登ERP我的分销商-供销对账明细
 */
export function loginErpMyChannelBillDetail(params: LoginErpMyChannelBillDetailUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpMyChannelBillDetail', { params })
}

// 联登ERP我的分销商-查看日志
/**
 * 联登ERP我的分销商-查看日志
 */
export function loginErpMyChannelLog(params: LoginErpMyChannelLogUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpMyChannelLog', { params })
}

// 联登ERP我的分销商-查看/编辑分销商详情
/**
 * 联登ERP我的分销商-查看/编辑分销商详情
 */
export function loginErpMyChannelSetDetail(params: LoginErpMyChannelSetDetailUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpMyChannelSetDetail', { params })
}

// 联登ERP分销资金明细-订单号-根据内部订单号查询订单详情
/**
 * 根据内部订单号查询订单详情
 */
export function loginErpOrderDetailByOwnerCoId(params: LoginErpOrderDetailByOwnerCoIdUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpOrderDetailByOwnerCoId', { params })
}

// 联登ERP售后自动推送
/**
 * 联登ERP我的供应商的售后自动推送配置
 */
export function loginErpMySupplierAfterSale(params: LoginErpMySupplierAfterSaleUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpMySupplierAfterSale', { params })
}

// erp 登录跳转通用接口（扩展请联系打单服务端同学）
export function loginErpForJumpUrl(data) {
    return printerRequest.post('/logistics/print/loginErpForJumpUrl', {
        data
    })
}
// 订单页面跳转ERP
/**
 * 联登ERP订单自动筛选配置
 */
export function jumpErp(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpOrderAutoFilterRule')
}

// 联登ERP售后订单详情
/**
 * 联登ERP售后详情页
 */
export function loginErpAfterSaleDetails(params: LoginErpAfterSaleDetailsUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpAfterSaleDetails', { params })
}

// 联登ERP账户管理
/**
 * 联登ERP账户管理
 */
export function loginErpAccountManage(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpAccountManage')
}

// 售后联登erp退款单
/**
 * 联登ERP退款单页面
 */
export function loginRefund(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginRefund')
}

// 联登erp库存同步上架日志
/**
 * 库存同步日志
 */
export function loginErpStockInventoryLog(): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpStockInventoryLog')
}

export const erpRefreshUserStatus = () =>
    securityRequest.get('/refresh/userStatus', {
        headers: {
            fountainhead: window.origin
        },
        credentials: 'same-origin' //  因为此处是需要携带erp的cookie做效验的，不能默认（omit）不发送cookie
    })

// 设置u-env
export const setUpUserEnvInCookie = params =>
    securityRequest.get('/security/user/setUpUserEnvInCookie', {
        headers: {
            fountainhead: window.origin
        },
        credentials: 'same-origin', //  因为此处是需要携带erp的cookie做效验的，不能默认（omit）不发送cookie
        params
    })

/**
 * 这两个服务端设置 cookie 的接口, allow-origin设置的为*, 在跨域时无效
 * 这里改为和网页同源域名规避
 */
export const erpRefreshUserStatusOnNoPrefix = () =>
    noPrefixRequest.get('/api/auth/refresh/userStatus', {
        headers: {
            fountainhead: window.origin
        },
        credentials: 'same-origin' //  因为此处是需要携带erp的cookie做效验的，不能默认（omit）不发送cookie
    })

// 设置u-env
export const setUpUserEnvInCookieOnNoPrefix = params =>
    noPrefixRequest.get('/api/auth/security/user/setUpUserEnvInCookie', {
        headers: {
            fountainhead: window.origin
        },
        credentials: 'same-origin', //  因为此处是需要携带erp的cookie做效验的，不能默认（omit）不发送cookie
        params
    })

// 查询公司是否支持创建店铺
/**
 * 查询公司是否支持创建店铺
 */
export function checkCreateShopRole(params: CheckCreateShopRoleUsingGetParams): API.Res<CheckCreateShopRoleResult> {
    return companyRequest.get('/shop/checkCreateShopRole', { params })
}
